import {Injectable} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {EditRemovalAssetDialogComponent, EditRemovalAssetDialogModel} from "./edit-removal-asset-dialog.component";
import {Apollo} from "apollo-angular";
import {AssetGqlModel, AssetInputGqlModel, AssetInputResponseGqlModel} from "./asset.gql-model";

@Injectable()
export class AssetRemovalService {
  constructor(
    private apollo: Apollo,
    private dialogService: DialogService,
  ) {}

  getAsset(assetId: string): Promise<AssetGqlModel> {
    const query = AssetGqlModel.query;
    const variables = AssetGqlModel.variables(assetId);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(AssetGqlModel.mapper)
      .toPromise();
  }

  async saveAsset(asset: AssetGqlModel): Promise<AssetInputResponseGqlModel> {
    const inputObject = new AssetInputGqlModel({asset, assetId: asset.id});
    const mutation = inputObject.mutation;
    const variables = inputObject.variables;

    return this.apollo.mutate({mutation, variables, fetchPolicy: "no-cache"})
      .pipe(AssetInputGqlModel.mapper)
      .toPromise();
  }

  editAsset(assetId: string): Promise<boolean> {
    return this.dialogService.showDialog(EditRemovalAssetDialogComponent, {assetId} as EditRemovalAssetDialogModel);
  }
}
